/* eslint-disable */
// @ts-nocheck
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetIsShowSegmentModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetIsShowSegmentModalQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: number, isShowSegmentModal: boolean } };

export type SaveUserSegmentMutationVariables = Types.Exact<{
  segment: Types.GqlUserSegment;
}>;


export type SaveUserSegmentMutation = { __typename?: 'Mutation', saveUserSegment: { __typename?: 'UserType', id: number, isShowSegmentModal: boolean } };


export const GetIsShowSegmentModalDocument = gql`
    query GetIsShowSegmentModal {
  user {
    id
    isShowSegmentModal
  }
}
    `;

/**
 * __useGetIsShowSegmentModalQuery__
 *
 * To run a query within a React component, call `useGetIsShowSegmentModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsShowSegmentModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsShowSegmentModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsShowSegmentModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>(GetIsShowSegmentModalDocument, options);
      }
export function useGetIsShowSegmentModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>(GetIsShowSegmentModalDocument, options);
        }
// @ts-ignore
export function useGetIsShowSegmentModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>;
export function useGetIsShowSegmentModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIsShowSegmentModalQuery | undefined, GetIsShowSegmentModalQueryVariables>;
export function useGetIsShowSegmentModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>(GetIsShowSegmentModalDocument, options);
        }
export type GetIsShowSegmentModalQueryHookResult = ReturnType<typeof useGetIsShowSegmentModalQuery>;
export type GetIsShowSegmentModalLazyQueryHookResult = ReturnType<typeof useGetIsShowSegmentModalLazyQuery>;
export type GetIsShowSegmentModalSuspenseQueryHookResult = ReturnType<typeof useGetIsShowSegmentModalSuspenseQuery>;
export type GetIsShowSegmentModalQueryResult = ApolloReactCommon.QueryResult<GetIsShowSegmentModalQuery, GetIsShowSegmentModalQueryVariables>;
export const SaveUserSegmentDocument = gql`
    mutation SaveUserSegment($segment: GqlUserSegment!) {
  saveUserSegment(segment: $segment) {
    id
    isShowSegmentModal
  }
}
    `;
export type SaveUserSegmentMutationFn = ApolloReactCommon.MutationFunction<SaveUserSegmentMutation, SaveUserSegmentMutationVariables>;

/**
 * __useSaveUserSegmentMutation__
 *
 * To run a mutation, you first call `useSaveUserSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserSegmentMutation, { data, loading, error }] = useSaveUserSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useSaveUserSegmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUserSegmentMutation, SaveUserSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUserSegmentMutation, SaveUserSegmentMutationVariables>(SaveUserSegmentDocument, options);
      }
export type SaveUserSegmentMutationHookResult = ReturnType<typeof useSaveUserSegmentMutation>;
export type SaveUserSegmentMutationResult = ApolloReactCommon.MutationResult<SaveUserSegmentMutation>;
export type SaveUserSegmentMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveUserSegmentMutation, SaveUserSegmentMutationVariables>;